// sessionManager.js
import { signOut } from 'aws-amplify/auth';
import { FRONT_END_DOMAIN } from '../../utils/LS-CONSTANT';

class SessionManager {
    constructor() {
        this.TIMEOUT = 60 * 60 * 1000;       // 60 minutes
        this.WARNING_TIME = 2 * 60 * 1000; // warning at 2 seconds

        this.warningTimer = null;
        this.logoutTimer = null;
        this.loginUrl = null;
        this.isActive = false;
        this.showWarningCallback = null; // Callback to show MUI modal
    }

    start(loginUrl, showWarningCallback) {
        this.loginUrl = loginUrl;
        this.showWarningCallback = showWarningCallback;
        this.isActive = true;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
        this.resetTimers();
        this.setupActivityListeners();
    }

    setupActivityListeners() {
        ['mousedown', 'keypress', 'scroll', 'touchstart', 'mousemove', 'click'].forEach(event => {
            document.addEventListener(event, () => this.resetTimers(), true);
        });
    }

    resetTimers() {
        if (!this.isActive) return;

        clearTimeout(this.warningTimer);
        clearTimeout(this.logoutTimer);

        // Show warning 2 minutes before logout
        this.warningTimer = setTimeout(() => {
            this.showWarning();
        }, this.TIMEOUT - this.WARNING_TIME);

        // Auto logout
        this.logoutTimer = setTimeout(() => {
            this.performLogout();
        }, this.TIMEOUT);
    }

    showWarning() {
        if (this.showWarningCallback) {
            this.showWarningCallback();
        }
    }

    continueSession() {
        this.resetTimers();
    }

    async performLogout() {
        try {
            this.isActive = false;

            // Clear Duo cookies
            document.cookie.split(";").forEach((c) => {
                document.cookie = c
                    .replace(/^ +/, "")
                    .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });

            // Sign out from Cognito
            await signOut();

            // Clear localStorage
            localStorage.clear();
        } catch (error) {
            console.error('Error during auto-logout:', error);
        } finally {
            // Always redirect to login
            // if loginUrl is not set to app.xman.com then appear as http://localhost:3000/app.xman.com
            window.location.href = `https://${FRONT_END_DOMAIN}`;
        }
    }

    stop() {
        this.isActive = false;
        clearTimeout(this.warningTimer);
        clearTimeout(this.logoutTimer);

        ['mousedown', 'keypress', 'scroll', 'touchstart', 'mousemove', 'click'].forEach(event => {
            document.removeEventListener(event, () => this.resetTimers(), true);
        });
    }
}

export default new SessionManager();
